export const HELP_SECTION_URL = '/#faq-section'
